import { ITimeBlockComponentItem } from '../../../types/time-block-component-item-types';
import { TimeBlockContentType } from '../../../types/time-block-types';
import {
  SlotTimeBlockModel,
  TimeBlockModel,
} from '../../../../../../../core/models/timeblock/time-block.model';

export class SlotMonthViewTimeBlockFacade implements ITimeBlockComponentItem {
  public realTimeBlock = null;
  id: number;
  timeBlockContentType: TimeBlockContentType;
  timeBlockModel: TimeBlockModel;

  public static fromITimeBlockComponentItem(
    timeBlock: ITimeBlockComponentItem,
    adaptedStart: Date,
    adaptedEnd: Date,
  ): SlotMonthViewTimeBlockFacade {
    const slotMonthViewTimeBlock = new SlotMonthViewTimeBlockFacade();
    slotMonthViewTimeBlock.realTimeBlock = timeBlock;
    slotMonthViewTimeBlock.timeBlockModel = new SlotTimeBlockModel();
    slotMonthViewTimeBlock.timeBlockModel.start = adaptedStart;
    slotMonthViewTimeBlock.timeBlockModel.end = adaptedEnd;
    return slotMonthViewTimeBlock;
  }

  clone(): ITimeBlockComponentItem {
    return undefined;
  }

  insertIntoCalendar(): void {}

  removeFromCalendar(): void {}
}
